export default {
  home: {
    sections: {
      trendingToday: "In tendenza oggi",
      offers: "Offerte",
      partners: "Partner",
      cheatsheets: "Schede rapide",
      predictionMarkets: "Mercati predittivi",
      advancedTools: "Strumenti avanzati",
      parlays: "Parlay",
      upcomingGames: "Prossime partite",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Scelte giornaliere",
        BOOST: "Boost",
        SPORTSBOOK_SIGNUP: "Sportsbook",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Pronostico",
        SWEEPSTAKES_SIGNUP: "Concorsi",
        CASINO_SIGNUP: "Casinò",
        PARTNER: "Partner",
      },
    },
    offseason: {
      eyebrow: "Fuori stagione",
      body: "Ci vediamo presto per la nuova stagione!",
    },
    seasonChampion: {
      description: "{{team}} sono i {{championship}}.",
      descriptionWithArticle: "I {{team}} sono i {{championship}}.",
      descriptions: {
        default: "Campioni {{league}}",
        superbowl: "Campioni del Super Bowl",
        stanleyCup: "Campioni della Stanley Cup",
        premierLeague: "Campioni della Premier League",
        worldSeries: "Campioni delle World Series",
        european: "Campioni d'Europa",
        europaLeague: "Campioni di Europa League",
        ncaaBasketball: "Campioni NCAA di basket",
        ncaaFootball: "Campioni NCAA di football",
      },
    },
    noGamesToday: "Oggi non ci sono partite nella {{league}}.",
    currentlyInOffseason: "Attualmente fuori stagione.",
    featured: {
      gameOfDay: "Partita del giorno",
      gameOfWeek: "Partita della settimana",
      parlayTrends: "Trend parlay",
      cheatsheets: "Schede rapide",
      unlockRewardTitle: "Sblocca la tua ricompensa",
      unlockRewardSubtitle: "Riscatta l'accesso premium per vedere di più.",
      unlockRewardBody: "Accedi a più trend, strumenti e insight.",
    },
    cards: {
      placeItOn: "Scommetti su",
      advancedToolsCta: "Iscriviti a Linemate+",
      premiumBlurb: "Sblocca l'esperienza completa. Approfondisci ogni trend.",
    },
    empty: {
      trend: "Nessun trend disponibile. Riprova più tardi.",
      cheatsheet: "Nessuna scheda rapida disponibile. Riprova più tardi.",
      offer: "Nessuna offerta disponibile. Riprova più tardi.",
    },
    cheatsheets: {
      recentForm: "Forma recente",
      versusOpponent: "Contro avversario",
      alternateLines: "Linee alternative",
      firstQuarter: "1º quarto",
      firstHalf: "1º tempo",
      homeAwayGames: "Partite casa/trasferta",
      teamForm: "Forma squadra",
      undersOnly: "Solo under",
    },
    tools: {
      props: "Props",
      markets: "Mercati",
      cheatsheets: "Schede rapide",
      generateParlay: "Creatore di multiple",
      lineups: "Formazioni",
      injuries: "Infortuni",
      rank: "Ranking",
      weather: "Meteo",
      pitchers: "Lanciatori",
      stats: "Statistiche",
      standings: "Classifiche",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Usa la forma recente, i precedenti o il rendimento in casa e in trasferta.",
        recentFormDescription: "Rendimento nelle ultime 20 partite",
        versusOpponentDescription: "Ultime 20 partite contro questo avversario",
        homeAwaySplitsDescription: "Ultime 20 partite in casa o in trasferta",
      },
      legs: {
        title: "Quante selezioni vuoi?",
        subtitle: "Scegli quanto deve essere grande la multipla che vuoi generare",
        label: "{{count}} selezioni",
      },
      participants: {
        title: "Chi vuoi includere?",
        subtitle: "Scegli le squadre o i giocatori che vuoi nella tua multipla",
        searchPlayer: "Cerca un giocatore",
        searchTeam: "Cerca una squadra",
        allPlayers: "Tutti i giocatori",
        allTeams: "Tutte le squadre",
      },
      result: {name: "Multipla", title: "La tua multipla"},
      empty: {
        title: "Nessuna multipla trovata",
        subtitle: "Prova a cambiare le selezioni per creare una multipla.",
      },
      actions: {goHome: "Torna alla home", share: "Condividi la multipla"},
      loader: {
        ready: "Multipla pronta",
        accessibilityLabel: "Generazione della tua multipla",
        values: {
          legs: "{{count}} selezioni...",
          allGames: "Tutte le partite...",
          selectedGames: "{{count}} partite...",
          allPlayers: "Tutti i giocatori...",
          allTeams: "Tutte le squadre...",
          selectedParticipants: "{{count}} partecipanti...",
          selectedBetTypes: "{{count}} tipi di scommessa...",
          selectedSportsbooks: "{{count}} sportsbook...",
          building: "Creazione della tua multipla...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Hub mercati predittivi",
      values: {
        points: "{{count}} pts",
        trades: "{{count}} scambi",
      },
      analysis: {
        title: "Analisi mercato",
        allExchanges: "Tutti gli exchange",
        perExchange: "Per exchange",
        chips: {
          all: "Tutto",
          oneDay: "1 giorno",
          oneWeek: "1 settimana",
        },
        rows: {
          volume: "Volume",
          movement: "Movimento",
          marketSplit: "Divario mercato",
          largestTrade: "Scambio più grande",
          activity: "Attività",
        },
      },
      cards: {
        mostVolume: {
          title: "Volume maggiore",
          description: "Mercati con più denaro scambiato",
        },
        largestTrades: {
          title: "Scambi più grandi",
          description: "Mercati con i maggiori scambi individuali",
        },
        biggestMovers: {
          title: "Movimenti maggiori",
          description: "Mercati con i maggiori cambiamenti di probabilità",
        },
        marketsSplit: {
          title: "Divario mercati",
          description: "Mercati con le maggiori differenze tra piattaforme",
        },
        mostActivity: {
          title: "Maggiore attività",
          description: "Mercati con il maggior numero di scambi",
        },
      },
      previews: {
        superBowlWinner: "Vincitore del Super Bowl",
        nbaChampions: "Campioni NBA",
        worldSeriesWinner: "Vincitore delle World Series",
        easternConference: "Eastern Conference",
        westernConference: "Western Conference",
        nfcWinner: "Vincitore NFC",
        afcChampions: "Campioni AFC",
        alPennant: "Pennant AL",
        stanleyCup: "Stanley Cup",
        afcEast: "AFC East",
        afcNorth: "AFC North",
        nfcNorth: "NFC North",
        nfcWest: "NFC West",
        nlCentral: "NL Central",
        nlWest: "NL West",
        premierLeague: "Premier League",
        divisionWinner: "Vincitore division",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} contro",
      vsOpponent: "vs {{opponent}}",
    },
    sponsoredBy: "Sponsorizzato da {{operator}}",
  },
};
